import { Icon, Text, HStack, VStack, VStackTypes } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import React, { useCallback } from 'react';
import { Pressable } from 'react-native';

import { TableContent, TableContentItemColumn } from '../../../../../../../components/TableContent';
import { useWithValueVisibility } from '../../../../../../../hooks/useWithValueVisibility';
import { getFlex } from '../utils';

import { InvestmentStrategyItemTypes } from './types';

const defaultVStackProps: VStackTypes.Props = {
  space: Spacing['stack.quarck'],
  flex: 1,
};

export const InvestmentStrategyItemMobile: React.FC<InvestmentStrategyItemTypes.Props> = ({
  item,
}) => {
  const withValueVisibility = useWithValueVisibility();
  const [expanded, setExpanded] = React.useState(false);

  const toggleExpand = useCallback(() => {
    setExpanded((state) => !state);
  }, []);

  return (
    <TableContent
      direction="row"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}
      flexWrap="wrap">
      <TableContentItemColumn flex={getFlex(0)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Data</Text>
          <Text>{withValueVisibility(item.partitionDateNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Cliente</Text>
          <Text>{withValueVisibility(item.customerNameNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex="none">
        <Pressable onPress={toggleExpand}>
          <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size="xs" />
        </Pressable>
      </TableContentItemColumn>
      {expanded && (
        <VStack
          padding={Spacing['inset.xs']}
          space={Spacing['stack.nano']}
          marginTop={Spacing['inline.xxxs']}
          borderRadius={BoxRadius.sm}
          backgroundColor={Color.background}
          width="100%">
          <HStack justifyContent="space-between">
            <Text>Conta de custódia</Text>
            <Text>{withValueVisibility(item.customerCustodyAccountNumberNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Conta Sinacor</Text>
            <Text>{withValueVisibility(item.customerAccountNumberNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Total PL</Text>
            <Text>{withValueVisibility(item.plValueNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Estado</Text>
            <Text>{withValueVisibility(item.stateNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Nome do assessor</Text>
            <Text>{withValueVisibility(item.advisorNameNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Filial</Text>
            <Text>{withValueVisibility(item.branchNameNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Suitability</Text>
            <Text>{withValueVisibility(item.suitabilityNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Telefone</Text>
            <Text>{withValueVisibility(item.phoneNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Situação</Text>
            <Text>{withValueVisibility(item.statusNormalized)}</Text>
          </HStack>
        </VStack>
      )}
    </TableContent>
  );
};
